<ul [class.is-dark-mode]="isDarkMode">
  <li
    class="test-has-min-length"
    [class.matched]="hasMinLength"
  >
    <i class="icon-CheckCircleRounded"></i>
    <span></span>
    Password minimum length: 12 character(s)
  </li>
  <li
    class="test-has-number"
    [class.matched]="hasNumber"
  >
    <i class="icon-CheckCircleRounded"></i>
    <span></span>
    Contains at least 1 number
  </li>
  <li
    class="test-has-special-character"
    [class.matched]="hasSpecialCharacter"
  >
    <i class="icon-CheckCircleRounded"></i>
    <span></span>
    Contains at least 1 special character
  </li>
  <li
    class="test-has-uppercase"
    [class.matched]="hasUppercase"
  >
    <i class="icon-CheckCircleRounded"></i>
    <span></span>
    Contains at least 1 uppercase letter
  </li>
  <li
    class="test-has-lowercase"
    [class.matched]="hasLowercase"
  >
    <i class="icon-CheckCircleRounded"></i>
    <span></span>
    Contains at least 1 lowercase letter
  </li>
</ul>
